import React, { useState } from 'react';
import { FaCalendarAlt, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import CalendarGrid from './CalendarGrid';
import BookingsList from './BookingsList';
import AvailabilityManager from './AvailabilityManager';
import PricingSettings from './PricingSettings';

const CalendarView: React.FC = () => {
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [view, setView] = useState<'month' | 'list'>('month');
  
  // Function to navigate to previous month
  const prevMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
  };
  
  // Function to navigate to next month
  const nextMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));
  };
  
  // Function to format month and year
  const formatMonthYear = (date: Date) => {
    return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  };
  
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold text-gray-800 flex items-center">
          <FaCalendarAlt className="mr-2 text-blue-600" />
          Booking Calendar
        </h2>
        
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <button
              onClick={prevMonth}
              className="p-2 rounded-full hover:bg-gray-100"
              aria-label="Previous month"
            >
              <FaChevronLeft />
            </button>
            <span className="font-medium text-gray-700 w-40 text-center">
              {formatMonthYear(currentMonth)}
            </span>
            <button
              onClick={nextMonth}
              className="p-2 rounded-full hover:bg-gray-100"
              aria-label="Next month"
            >
              <FaChevronRight />
            </button>
          </div>
          
          <div className="flex border rounded-md overflow-hidden">
            <button
              className={`px-4 py-2 ${view === 'month' ? 'bg-blue-600 text-white' : 'bg-white text-gray-700'}`}
              onClick={() => setView('month')}
            >
              Month
            </button>
            <button
              className={`px-4 py-2 ${view === 'list' ? 'bg-blue-600 text-white' : 'bg-white text-gray-700'}`}
              onClick={() => setView('list')}
            >
              List
            </button>
          </div>
        </div>
      </div>
      
      {view === 'month' ? (
        <div className="bg-white rounded-lg shadow">
          <CalendarGrid currentDate={currentMonth} />
        </div>
      ) : (
        <div className="bg-white rounded-lg shadow p-4">
          <BookingsList />
        </div>
      )}
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        <AvailabilityManager />
        <PricingSettings />
      </div>
    </div>
  );
};

export default CalendarView;
